import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * WarningBanner - Displays language fallback warning when deck contains cards
 * from a different language than selected
 * shadcn/ui version
 */
export default function WarningBannerShadcn({
  languageFallbackCount,
  language,
}) {
  const { t } = useLanguage();

  if (languageFallbackCount === 0) {
    return null;
  }

  return (
    <Alert variant="warning" className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>{t('deck.warnings.title', 'Language Notice')}</AlertTitle>
      <AlertDescription>
        {t('deck.warnings.languageMismatch', 
          `This deck contains ${languageFallbackCount} card(s) that are not available in ${language}`,
          { count: languageFallbackCount, language }
        )}
      </AlertDescription>
    </Alert>
  );
}
